/**
 * Stimulus Controller: upload-file-size-restriction
 * This controller restricts the size of files uploaded through input fields.
 *
 * Usage:
 * Add the `data-controller="upload-file-size-restriction"` attribute to a file input field.
 * Optionally, specify a custom maximum file size in MB using the `data-max-size` attribute.
 * If `data-max-size` is not provided, the default maximum file size is 2 MB.
 *
 * Example:
 * <input type="file"
 *        data-controller="upload-file-size-restriction"
 *        data-max-size="5"
 *        data-error=t("activerecord.errors.models.unassigned_bank_transaction.attributes.attachment.size", size: 24)
 *        accept=".jpg,.png,.pdf">
 *
 * To use this controller, include the following line in your layout:
 * - content_for :js, javascript_include_tag("front/situational/upload-file-size-restriction.js")
 */

stimulusApp.register(
  "upload-file-size-restriction",
  class extends Stimulus.Controller {
    static values = { maxSize: { type: Number, default: 2 } } // Default max size in MB

    connect() {
      this.element.addEventListener("change", this.checkFileSize)

      if (!this.element.dataset.error) {
        throw new Error(
          'The "upload-file-size-restriction" controller requires the "data-error" attribute to be set.',
        )
      }
    }

    disconnect() {
      this.element.removeEventListener("change", this.checkFileSize)
    }

    checkFileSize = (event) => {
      const maxSizeMb = this.element.dataset.maxSize
        ? parseFloat(this.element.dataset.maxSize)
        : this.maxSizeValue

      const maxSizeBytes = maxSizeMb * 1024 * 1024 // Convert MB to bytes
      const file = event.target.files[0] // Get the selected file

      if (file && file.size > maxSizeBytes) {
        alert(this.element.dataset.error)
        event.target.value = "" // Clear the file input
      }
    }
  },
)
